module.exports = __webpack_public_path__ + "f1775751cb35c8984bfe94ded03e9384.svg";